// Select payment
// Allows the user to toggle between payment options in step 3.
// Different options become available depending on the payment
// option selected.
// ----------------------------------------------------------------

import $ from 'jquery';

const selectPaymentMethodTrigger = $('.js-selectPaymentMethodTrigger');
const selectPaymentMethodTarget = $('.js-selectPaymentMethodTarget');
const selectDueDateTarget = $('.js-selectDueDateTarget');
const selectDueDateInputs = $('.js-selectDueDateTarget input');
const donationTypeOutput = $('#donation_type');

$(selectPaymentMethodTrigger).on('click', function() {

    // Hides all payment options.
    $(selectPaymentMethodTarget).hide();

    // Release the requirement of options
    $('.js-selectPaymentMethodTarget input').prop('required', false);

    // Get ID of selected payment method.
    let selectPaymentMethodId = $(this)[0].id;

    // Show the appropriate payment method options.
    $('div[data-donation-payment-type="' + selectPaymentMethodId + '"]').show();

    // Show due date for monthly payment
    if (selectPaymentMethodId === 'donation-payment-type-net-banking' && $(donationTypeOutput).val() === 'monthly') {
        $(selectDueDateTarget).show();
        $(selectDueDateInputs).prop('required', true);
    } else {
        $(selectDueDateTarget).hide();
        $(selectDueDateInputs).prop('required', false);
    }

    // Set the selected options as required
    $('div[data-donation-payment-type="' + selectPaymentMethodId + '"] input').prop('required', true);
});
